export const DEFAULT_POST_AUTH_PATH = "/"

export function normalizePostAuthRedirect({
  next,
  origin,
  fallback = DEFAULT_POST_AUTH_PATH,
}) {
  if (!next) {
    return fallback
  }

  try {
    const url = new URL(next, origin)

    if (url.origin !== origin) {
      return fallback
    }

    const redirectPath = `${url.pathname}${url.search}${url.hash}`

    if (
      !redirectPath.startsWith("/") ||
      redirectPath.startsWith("//") ||
      redirectPath.startsWith("/auth/callback")
    ) {
      return fallback
    }

    return redirectPath
  } catch {
    return fallback
  }
}

export function buildOAuthRedirectTo({
  origin,
  next,
  fallback = DEFAULT_POST_AUTH_PATH,
}) {
  const redirectPath = normalizePostAuthRedirect({
    next,
    origin,
    fallback,
  })
  const callbackUrl = new URL("/auth/callback", origin)

  callbackUrl.searchParams.set("next", redirectPath)

  return callbackUrl.toString()
}
